const auditLog = {
  searchPlaceholder: "חיפוש בלוג...",
  filters: "סינון",
  clearFilters: "נקה סינון",
  refresh: "רענן",
  source: "מקור",
  actorType: "סוג שחקן",
  dateFrom: "מתאריך",
  dateTo: "עד תאריך",
  allSources: "כל המקורות",
  systemLogs: "לוג מערכת",
  documentLogs: "לוג מסמכים",
  allActors: "כל השחקנים",
  actorUser: "משתמש",
  actorSubmitter: "חותם",
  actorSystem: "מערכת",
  actorAutomation: "אוטומציה",
  colTimestamp: "זמן",
  colSource: "מקור",
  colActor: "שחקן",
  colAction: "פעולה",
  colTarget: "יעד",
  noEntries: "אין רשומות ביומן",
  showing: "מציג",
  of: "מתוך",
  oldData: "ערך קודם",
  newData: "ערך חדש",
} as const;
export default auditLog;
